// import * as Redux from "redux";
// import { IUpdateError, IAction } from "./Models";

const defaultOptions = {
	credentials: "same-origin",
	headers: {
		"Accept": "application/json",
		"Content-Type": "application/json",// För json posts, browsern skickar annars text/plain
		"Accept-Language": (typeof document !== 'undefined' ? document.documentElement.lang : 'sv-SE')
	}
};

export interface IUpdateError {
	field?: string;
	message?: string;
}


export async function fetchJson<T>(url: string, init?: RequestInit) {
	let initOptions = Object.assign({}, defaultOptions, init) as RequestInit;

	//CSRF-skydd
	if (document) {
		let tokenElement = document.querySelector('input[name=__RequestVerificationToken]') as HTMLInputElement;
		let token = tokenElement ? tokenElement.value : null;
		if (token) {
			initOptions.headers['X-CSRF-TOKEN'] = token;
		}
	}

	// Spara undan ett promise-objekt utan catch-handler så att extern felhanterning också kan köras
	let promise = fetch(url, initOptions);

	// Koppla på en intern handler som skickar felrapporter till servern för t.ex.
	// CORS-fel, felaktiga URLer, och andra fel som resulterar att anropet inte kan utföras
	// promise.catch(handleFatalFetchError(url));

	// Koppla på handleResult först efter den föregående felloggningen för att inte
	// logga fel för sådant som redan loggas på servern.
	const response = await promise;
	return await handleResult<T>(response);
}

// export function createErrorHandler(dispatch: Redux.Dispatch<IAction>, errorAction: (errors ?: IUpdateError[]) => IAction) {
// 	return (error: IFetchJsonException) => {
// 		if (error.type === FetchErrorTypes.UnprocessableException) {
// 			error.getErrors().then(errors => dispatch(errorAction(errors)));
// 		}
// 		else {
// 			dispatch(errorAction());
// 		}
// 	};
// }

export enum FetchErrorTypes {
	UnhandledException,
	UnprocessableException,
	Unauthorized
}

export interface IFetchJsonException {
	type: FetchErrorTypes;
	message: string;
	errors: IUpdateError[];
	response: Response;
}

async function handleResult<T>(response: Response) {
	if (!response.ok) {
		let errorType: FetchErrorTypes;
		//defaultimplementation som inte returnerar några fel
		//let getErrors = () => response.text().then(t => [] as IUpdateError[]);
		let errors = [] as IUpdateError[];
		let message = "Servern svarade med fel.";

		switch (response.status) {
			case 401:
				// Saknar behörighet, antagligen utloggad.
				// Ladda om sidan så den gör en redirect till inloggningssidan.
				errorType = FetchErrorTypes.Unauthorized;
				window.location.reload();
				break;
			case 422:
				// Valideringsfel eller annat "snyggt" fel från serversidan
				errorType = FetchErrorTypes.UnprocessableException;
				const errorResult = await response.json();
				message = errorResult.message;
				errors = errorResult.errors;
				// getErrors = () => response.json().then(errorResult => {
				// 	return errorResult.errors.map(e => { return { message: e }; });
				// });
				break;
			default:
				errorType = FetchErrorTypes.UnhandledException;
				break;
		}

		throw {
			type: errorType,
			message,
			errors,
			response
		} as IFetchJsonException;
	}

	if (response.status === 202 || response.status === 204) //Accepted or No Content - The server successfully processed the request and is not returning any content.
		return null;

	return response.json() as Promise<T>;
}